import React from "react";
import "./header.css";
import Form from "react-bootstrap/Form";

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasScrolled: false,
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  handleScroll = (event) => {
    const scrollTop = window.pageYOffset;

    if (scrollTop > 50) {
      this.setState({ hasScrolled: true });
    } else {
      this.setState({ hasScrolled: false });
    }
  };

  render() {
    var arabic = this.props.arabic;
    return (
      <div>
        <div
          className={
            this.state.hasScrolled ? "Header HeaderScrolled" : "Header"
          }
        >
          <div
            className="HeaderGroup"
            style={{
              display: "flex",
              direction: arabic ? "rtl" : "ltr",
            }}
          >
            <img src={require("../assets/soul.png")} width="200" alt="img" />
            <Form
              style={{
                marginLeft: arabic ? 16 : "auto",
                marginRight: arabic ? "auto" : 16,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
              }}
            >
              <div
                style={{
                  marginRight: arabic ? 0 : 8,
                  marginLeft: arabic ? 8 : 0,
                }}
              >
                {arabic ? "اللغة" : "Language"}
              </div>
              <Form.Control
                as="select"
                custom
                onChange={(event) => {
                  var value = event.target.value;
                  this.props.setLang(value, this.props.self);
                }}
              >
                <option value="en">English</option>
                <option value="ar">Arabic</option>
              </Form.Control>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
